module.exports = __webpack_public_path__ + "static/media/es-ct.e6db39f3.svg";